

import ausShep from '../assets/images/aus-shep.webp';
import treatTime2 from '../assets/images/treat-time2.jpg';
import daycare01 from '../assets/images/daycare-gallery/daycare-01.webp';
import daycare11 from '../assets/images/daycare-gallery/daycare-11.webp';



const serviceTileInfo = [
  {
    title: 'Boarding',
    imageUrl: daycare11,
    altTag: 'Dog in daycare facility',
    content: [
      'Looking for a loving place for your pup to stay? Our boarding services go beyond traditional kennels, providing a safe, caring environment where your dog will feel right at home.',
    ],
    navigation: 'boarding-service-info'
  },
  {
    title: 'Daycare',
    imageUrl: daycare01,
    altTag: 'Dog in daycare facility',
    content: [
      "Our daycare program offers fun-filled, supervised play tailored to your dog's size and temperament. With Half Day and Full Day options, recurring schedules, and package discounts, your pup will enjoy structured socialization and endless tail wags.",
    ],
    navigation: 'daycare-service-info'
  },
  {
    title: 'Add-Ons & Enrichment',
    imageUrl: ausShep,
    altTag: 'Dog enjoying enrichment activities',
    content: [
      "Elevate your pup's day with our range of add-ons! From lick puzzles and stuffed Kongs to nail trims, teeth brushing, neighborhood walks, and dedicated 1-on-1 play sessions \u2014 we offer plenty of ways to keep your dog happy, stimulated, and feeling their best.",
    ],
    navigation: 'prices'
  },
  // {
  //   title: 'Bus Service',
  //   imageUrl: bus1,
  //   altTag: 'Dog participating in obedience training',
  //   content: [
  //     'Need a lift for your pup? Our morning and evening bus service makes daycare or boarding easy for you and exciting for them. Start and end your day knowing your dog is in great hands.',
  //   ],
  //   navigation: 'bus-service-info'
  // },
  {
    title: 'Treat Times',
    imageUrl: treatTime2,
    altTag: 'Mission Bay Dog with a Kong treat',
    content: [
      "Make your pup's stay even more exciting with our food-based enrichment! Stuffed Kongs, Lick Puzzles, and Functional Bowl Boosts provide fun, relaxation, and a healthy treat for your dog to enjoy.",
    ],
    navigation: 'prices'
  },
  // {
  //   title: 'Boarding with Training',
  //   imageUrl: trainingTime2,
  //   altTag: 'Dog enjoying one-on-one time',
  //   content: [
  //     'Elevate your dog's stay with our boarding and training program. Tailored training sessions combined with overnight care ensure your pup leaves with improved manners, confidence, and lots of love.',
  //   ],
  //   navigation: 'boarding-training-service-info'
  // },
  // {
  //   title: 'Pack Hikes',
  //   imageUrl: packHike,
  //   altTag: 'Dog participating in obedience training',
  //   content: [
  //     'Add some adventure to your dog's routine with our on-leash pack hikes. Available Monday through Friday, these hikes offer enrichment, structured activity, and a chance to reinforce good manners in the great outdoors.',
  //   ],
  //   navigation: 'pack-hikes-service-info'
  // },
  // {
  //   title: 'Training Services',
  //   imageUrl: training4,
  //   altTag: 'Mission Bay Dog with a Kong treat',
  //   content: [
  //     'Enhance your dog's experience with our training sessions led by a CPDT-certified trainer. Whether mastering the basics or exploring enrichment activities, your pup will enjoy a workout for their mind and body.',
  //   ],
  //   navigation: 'boarding-training-service-info'
  // },
];

export default serviceTileInfo;
